import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface FarmStore {
  selectedFarmId: string | null;
  // Accepts null to clear a stale selection (e.g. the selected farm was deleted).
  setSelectedFarmId: (farmId: string | null) => void;
}

export const useFarmStore = create<FarmStore>()(
  persist(
    (set) => ({
      selectedFarmId: null,
      setSelectedFarmId: (farmId: string | null) => set({ selectedFarmId: farmId }),
    }),
    {
      name: 'hiponhero-farm',
    }
  )
);
